import { AssignmentChangeStatus, Cancellation, PaymentStatus, PositionNumber, PositionNumberType, castConstantType } from 'api/common/constants'
import { positionSelectAPI, positionsAPI } from 'api/position'
import Footer from 'components/Footer'
import Header from 'components/Header'
import MenuItems, { ListItemProps } from 'components/MenuItems'
import { PositionListCard, PositionProps, PositionState } from 'components/PositionListCard'
import * as React from 'react'
import { Toast, ToastContainer } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import loginData from 'utilities/loginData'

const SceneComponent: React.FC = () => {
  const navigate = useNavigate()
  const [positions, setPositions] = React.useState<PositionProps[]>([])
  const [showToast, setShowToast] = React.useState(false)
  const [isSpinningSubmit, setIsSpinningSubmit] = React.useState(false)
  const [menuItems, setMenuItems] = React.useState<ListItemProps[]>([])

  /**
   * ポジション契約へ
   * @param position ポジション情報
   */
  const onContractConnector = async (position: PositionProps) => {
    setIsSpinningSubmit(true)
    await positionSelectAPI({ positionCount: 1, positionNumber: position.positionNumber }, (result) => {
      if (result) {
        loginData.setPositionContractSelectedData({
          additionPositionCount: 1,
          selectedPositionNumber: position.positionNumber!,
        })
        navigate('/positionContract', { state: { fromPositionManagement: true } })
      }
    })
    setIsSpinningSubmit(false)
  }

  React.useEffect(() => {
    positionsAPI((result) => {
      const positionCount = Math.max(result.maxPositionCount, result.positions.length)
      const positionProps: PositionProps[] = []
      for (let i = 0; i < positionCount; i++) {
        const positionNumber = castConstantType<PositionNumberType>(i + 1, PositionNumber)
        const position = result.positions.find((position) => position.positionNumber === positionNumber)
        const name = positionNumber === PositionNumber.MainPosition ? 'メインポジション' : `サブポジション${i}`
        if (position) {
          positionProps.push({
            name,
            state: position.isChangedAssignment
              ? position.changeAssignmentStatus === AssignmentChangeStatus.Changed
                ? PositionState.ChangedAssignment
                : PositionState.ChangingAssignment
              : position.cancellationType !== Cancellation.Contract
                ? position.cancellationType === Cancellation.Unsubscribe
                  ? PositionState.Withdrawal
                  : PositionState.CoolingOff
                : position.paymentStatus === PaymentStatus.Paid
                  ? PositionState.Contracted
                  : PositionState.UnContract,
            connectorId: position.positionId.toString(),
            atemQuestId: position.atemQuestId,
            connectorIntroductionLeftURL: position.inviteLeftUrl,
            connectorIntroductionRightURL: position.inviteRightUrl,
            userIntroductionURL: `${process.env.REACT_APP_ATEM_QUEST_INVITE_URL}${position.atemQuestId}`,
            positionNumber: castConstantType<PositionNumberType>(i + 1, PositionNumber),
          })
        } else {
          positionProps.push({
            name,
            state: PositionState.UnContract,
            connectorId: '',
            connectorIntroductionLeftURL: '',
            connectorIntroductionRightURL: '',
            atemQuestId: '',
            userIntroductionURL: '',
            positionNumber: castConstantType<PositionNumberType>(i + 1, PositionNumber),
          })
        }
        setPositions(positionProps)
      }
      const tmpMenuItems: ListItemProps[] = []
      tmpMenuItems.push({
        label: 'コネクター登録',
        path: '/positionSelect',
      })
      tmpMenuItems.push({
        label: '組織管理',
        path: '/organizationManagement',
      })
      setMenuItems(tmpMenuItems)
    })
  }, [])

  return (
    <>
      <Header title="コネクター登録・ポジション管理" />
      <main>
        <section>
          <MenuItems items={menuItems} className="mt-5" />
        </section>
        <section className="mx-4 my-5">
          <h3 className="mt-5 fw-bold">ポジション一覧</h3>
          {positions.map((position, index) => (
            <PositionListCard
              key={index}
              {...position}
              onToast={() => setShowToast(true)}
              onContractConnector={() => onContractConnector(position)}
              isSpinningSubmit={isSpinningSubmit}
            />
          ))}
        </section>
      </main>
      <ToastContainer className="p-3 position-fixed" position="bottom-center" style={{ zIndex: 1 }}>
        <Toast bg="dark" onClose={() => setShowToast(false)} show={showToast} delay={3000} autohide>
          <Toast.Body className="text-white">コピーしました</Toast.Body>
        </Toast>
      </ToastContainer>
      <Footer className="mt-5" />
    </>
  )
}

export default SceneComponent
